// Canonical URL builder for products.
//
// The marketplace uses a hierarchical URL structure so search engines and
// shoppers can read shop + brand context straight from the address bar:
//
//   • /product/<shop-slug>/<brand-slug>/<product-slug>   — branded items
//   • /product/<shop-slug>/<product-slug>                — unbranded items
//   • /product/<product-slug>                            — legacy fallback,
//        kept as a 301-style client redirect so old links never 404.
//
// Backend endpoints (`/api/products`, `/api/products/{slug}`,
// `/api/products/{slug}/related`) inject `seller_slug`, `brand_slug`, and
// `product_url_slug` on every product so the frontend can build the
// canonical URL without extra round-trips. `product_url_slug` differs
// from the raw `slug` when the latter was brand-prefixed (e.g.
// `biscottificio-grondona-corleggeri-250-g`) AND the URL path already
// contains that prefix as the shop segment — we strip it to avoid the
// `/product/<shop>/<shop>-<name>` duplicate. The full slug remains in
// DB so legacy bookmarks keep resolving via direct slug match; the
// short form is in `slug_aliases` so the new short URL also resolves.
export const buildProductUrl = (product) => {
    if (!product) return '/';
    // Prefer the de-prefixed URL slug, then the canonical DB slug, then
    // the product id (used for cart/order snapshots that don't carry a
    // slug at all).
    const productSlug = product.product_url_slug || product.slug || product.product_id;
    if (!productSlug) return '/';
    const shopSlug = (product.seller_slug || '').trim();
    const brandSlug = (product.brand_slug || '').trim();
    if (shopSlug && brandSlug) {
        return `/product/${shopSlug}/${brandSlug}/${productSlug}`;
    }
    if (shopSlug) {
        return `/product/${shopSlug}/${productSlug}`;
    }
    // Legacy / lean-data fallback. ProductDetail will swap the address
    // bar to the canonical hierarchical URL on first render.
    return `/product/${productSlug}`;
};
